import type { ReactNode } from 'react';

/**
 * What a View component shows for an absent value: its placeholder, muted, or nothing.
 * Nothing makes the surrounding DetailsRow disappear.
 */
export const ViewPlaceholder = ({ placeholder }: { readonly placeholder?: ReactNode }) =>
  placeholder === undefined ? null : <span className="text-muted">{placeholder}</span>;
